import React, { FC, ReactNode } from "react";
import "./chart-wrapper.scss";
import { useDispatch, useSelector } from "react-redux";

interface ChartWrapperProps {
    title: string;
    width: string;
    children?: ReactNode;
}

const ChartWrapper: FC<ChartWrapperProps> = ({children, title,width}) => {
  const dispatch: Function = useDispatch();
  const user = useSelector((state: any) => state.auth.user);

 return (
    <div className="chart-wrapper" style={{width:width}}>
        <div className="chart-wrapper__title">{title}</div>
        {children}
    </div>
  );
};

export default ChartWrapper;
